import Vue from "vue";

import PhysicalPurchasesDetail from "./PhysicalPurchasesDetail.vue";

export function load() {
    const selector = "physical-purchases-detail";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PhysicalPurchasesDetail, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
